import { render, staticRenderFns } from "./LinkQR030.vue?vue&type=template&id=2565cdfc&scoped=true&"
import script from "./LinkQR030.vue?vue&type=script&lang=js&"
export * from "./LinkQR030.vue?vue&type=script&lang=js&"
import style0 from "./LinkQR030.vue?vue&type=style&index=0&id=2565cdfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565cdfc",
  null
  
)

export default component.exports